import {Component, OnInit} from '@angular/core';
import moment from "moment";
import 'moment/locale/it';  // Importa la localizzazione italiana
import {ActivatedRoute, NavigationEnd, Router, RouterModule} from "@angular/router";
import {NgClass, NgForOf, NgIf} from "@angular/common";
import {DayService} from "../../services/day.service";
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import {provideNativeDateAdapter} from '@angular/material/core';
import {AuthService} from "../../services/auth.service";

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faCalendarDays,faPowerOff } from '@fortawesome/free-solid-svg-icons';
import Swal from "sweetalert2";
import {PrestazioneService} from "../../services/prestazione.service";
import {of, switchMap} from "rxjs";
import {environment} from "../../../environments/environment";

@Component({
  selector: 'app-header',
  standalone: true,
  providers: [provideNativeDateAdapter()],
  imports: [
    RouterModule,
    NgForOf,
    NgIf,
    FontAwesomeModule,
    FormsModule, MatFormFieldModule, MatInputModule, MatDatepickerModule
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.css'
})
export class HeaderComponent implements OnInit {

  // Modularità
  hasStampa: boolean = false;
  hasBlockList: boolean = false;

  //Icone FontAwesome
  faCalendarDays = faCalendarDays;
  faPowerOff = faPowerOff;

  day: string = '';
  today: string = moment().format('YYYY-MM-DD');
  yestarDay: string = moment().subtract(1, 'days').format('YYYY-MM-DD');
  weekDays: { day: string, name: string, dayString: string }[] = [];
  activeRoute: string = '';

  constructor(
    private dayService: DayService,
    private prestazioneService: PrestazioneService, // Servizio per la gestione delle prestazioni
    private authService: AuthService,
    private router: Router
  ) {
    // Ascolta i cambiamenti della route
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.activeRoute = event.urlAfterRedirects.split('/')[1];
        console.log(this.activeRoute);
      }
    });
  }

  onDateChange(event: any) {
    const selectedDate = moment(event.value).format('YYYY-MM-DD');
    this.router.navigate(['/calendario', selectedDate]);
  }

  ngOnInit() {
    moment.locale('it');  // Imposta la localizzazione su italiano

    // Inizializzo la modularità
    this.hasStampa = environment.hasStampa;
    this.hasBlockList = environment.hasBlockList;

    this.dayService.currentDay.subscribe(day => {
      this.day = day || this.today;
      this.updateWeekDays();
    });
  }

  updateWeekDays() {
    this.weekDays = [];
    for (let i = 0; i < 8; i++) {
      const day = moment(this.day).add(i, 'days');
      this.weekDays.push({
        day: day.format('DD/M'),
        name: day.format('ddd').toUpperCase(),
        dayString: day.format('YYYY-MM-DD')
      });
    }
  }

  onLogout(){
    Swal.fire({
      title: "Sei sicuro di voler uscire?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#FF2E77",
      cancelButtonColor: "#050A30",
      confirmButtonText: "Esci",
      cancelButtonText: "Annulla",
    }).then((result) => {
      if (result.isConfirmed) {
        this.authService.logout();
      }
    });
  }

  // Metodo per controllare se l'URL corrente è '/stampa/:day'
  isNoCalendarRoute(): boolean {
    const url = this.router.url;
    return url.startsWith('/stampa/') || url.startsWith('/change-password');
  }

  stampa() {
    const link = document.createElement('a');
    link.setAttribute('target', '_blank');
    link.setAttribute('href', 'assets/stampa.pdf');
    link.setAttribute('download', `stampa.pdf`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  // Blocco il negozio per un periodo
  blockPeriodo(){
    Swal.fire({
      title: `Chiudi il negozio per il periodo selezionato`,
      html: `
      <div style="text-align: left;">
        <label for="dataInizio">Data Inizio:</label>
        <input type="date" id="dataInizio" class="input mt-2" />
        <label for="dataFine">Data Fine:</label>
        <input type="date" id="dataFine" class="input mt-2" />
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: 'Conferma',
      cancelButtonText: 'Annulla',
      confirmButtonColor: "#FF2E77",
      cancelButtonColor: "#050A30",
      preConfirm: () => {
        const dataInizio = (document.getElementById('dataInizio') as HTMLInputElement).value;
        const dataFine = (document.getElementById('dataFine') as HTMLInputElement).value;

        if (!dataInizio || !dataFine) {
          Swal.showValidationMessage('Per favore, inserisci entrambe le date (Data Inizio e Data Fine).');
          return null; // Ritorna null per impedire il passaggio alla fase "then" se i campi sono vuoti
        }

        return { dataInizio, dataFine };
      }
    }).then((result) => {
      if (result.isConfirmed && result.value) {
        console.log('Data Inizio:', result.value.dataInizio);
        console.log('Data Fine:', result.value.dataFine);

        this.prestazioneService.blockPeriodo(result.value.dataInizio, result.value.dataFine)
          .pipe(
            switchMap((response) => {
              console.log("Periodo bloccato", response);

              Swal.fire({
                icon: 'success',
                title: `Negozio bloccato`,
                timer: 1000
              });

              return of(response);
            })
          )
          .subscribe({
            error: (error) => {
              console.error("Errore nella chiusira", error);

              Swal.fire({
                icon: 'error',
                title: 'Ops...',
                text: "Errore nell'inserimento del blocco del periodo",
                confirmButtonColor: '#050A30'
              });

            }
          });

      }
    });

  }

  protected readonly moment = moment;
}
